import { Entitlement } from '@aibees/shared/definition';

export function sortEntitlements(entitlements: Entitlement[]): Entitlement[] {
  return entitlements.sort((a, b) => {
    const orderA = Number(a.metadata.order) || 0;
    const orderB = Number(b.metadata.order) || 0;
    return orderA - orderB;
  });
}

export function groupEntitlementsByParent(
  entitlements: Entitlement[]
): Record<string, Entitlement[]> {
  return entitlements.reduce((groups, ent) => {
    const parentKey = ent.metadata.parent || 'no-parent'; // Group by parent, use "no-parent" if undefined
    if (!groups[parentKey]) {
      groups[parentKey] = [];
    }
    groups[parentKey].push(ent);
    return groups;
  }, {} as Record<string, Entitlement[]>);
}
